import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Input,
    Typography,
    useMediaQuery,
    Grid
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import IOSSwitchComponent from '../switch/iso-style-switch';
import { DisabledByDefault } from '@mui/icons-material';
import useServices from '../../hooks/useServices';

const WifiUserModel = ({reLogAccount, type="staff",openModel,handleSubmitUserUpdate,modelViewData=[],setIsModelOpen }) => {
    const [open, setOpen] = useState(false);
     const [userDetails, setUserDetails] = useState([]);
       // State to manage editable fields
    const [isEditing, setIsEditing] = useState([]);
    const [services] = useServices()


    

    useEffect(() => {
        setOpen(openModel);
       // console.log(services);
    }, [openModel]);

    useEffect(()=>{
        console.log(modelViewData)
        setUserDetails(modelViewData);
        setIsEditing({
        email: false,
        mobileNo: false,
        zoomStatus: false,
        accountStatus:false,
        })
    },[modelViewData])

    // User details state
   

  

    const handleClose = () => {
        setOpen(false);
        setIsModelOpen(false);
    };

     const handleSubmit = (status) => {

        const submittedData = {
            nic: userDetails.nic,
            terminateDate: userDetails.terminateDate,
        };
        handleSubmitUserUpdate(submittedData);

    };

    // Handle input change
    const handleChange = (e) => {
      console.log(e)
        const { name, value } = e.target;
        setUserDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    };

     const handleChangeSwitch = (value,valueId) => {
        setUserDetails((prevDetails) => ({
            ...prevDetails,
            [valueId]: value,
        }));
    };

    // Toggle edit mode
    const toggleEdit = (field) => {
        setIsEditing((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if the screen size is small

    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth={isMobile ? 'xs' : 'sm'} fullWidth>
                <DialogTitle>User Details</DialogTitle>
                <DialogContent>
                    <Grid container spacing={isMobile ? 1 : 3} sx={{ padding: isMobile ? 1 : 3 }}>
                       

                        <Grid item xs={12}>
                              {/* User Email */}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="subtitle1" fontWeight="bold" sx={{ minWidth: 120 }}>
                                      Name:
                                  </Typography>
                                  
                                  {/* Input and Icon */}
                                  <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                                      <Input 
                                          disabled={true}
                                          value={userDetails.name}
                                          sx={{ flexGrow: 1, mr: 1 }}  // Flex-grow allows the input to take up remaining space, margin-right for spacing
                                      />
                                      
                                  </Box>
                              </Box>
                              <Divider />
                          </Grid>

                          <Grid item xs={12}>
                              {/* User Email */}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="subtitle1" fontWeight="bold" sx={{ minWidth: 120 }}>
                                      NIC No:
                                  </Typography>
                                  
                                  {/* Input and Icon */}
                                  <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                                      <Input 
                                          disabled={true}
                                          value={userDetails.nic}
                                          sx={{ flexGrow: 1, mr: 1 }}  // Flex-grow allows the input to take up remaining space, margin-right for spacing
                                      />
                                      
                                  </Box>
                              </Box>
                              <Divider />
                          </Grid>

                   
                            <Grid item xs={12}>
                              {/* User Email */}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="subtitle1" fontWeight="bold" sx={{ minWidth: 150 }}>
                                      Terminate Date:
                                  </Typography>
                                  
                                  {/* Input and Icon */}
                                  <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                                      <Input 
                                          disabled={!isEditing.email}
                                          type='date'
                                          value={userDetails.terminateDate}
                                          name="terminateDate"
                                          onChange={handleChange}
                                          sx={{ flexGrow: 1, mr: 1 }}  // Flex-grow allows the input to take up remaining space, margin-right for spacing
                                      />
                                      <IconButton size="small" color="primary" onClick={() => toggleEdit('email')}>
                                        {isEditing.email ? 
                                        <>
                                        <Button variant='contained' onClick={()=>handleSubmit("terminateDate")}>
                                            Update
                                        </Button><DisabledByDefault style={{ color:'red' }} fontSize="small" />
                                        </> : <EditOutlinedIcon fontSize="small" />}
                                         
                                      </IconButton>
                                  </Box>
                              </Box>
                              <Divider />
                          </Grid>
                       

                        

                       
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                    {(services?.userInitialData?.empNo === "12394" || services?.userInitialData?.empNo === "12393" || services?.userInitialData?.empNo === "1914") && (
                       <Button onClick={()=>reLogAccount(userDetails.email)}>
                        User Account
                        </Button>
                    )}

                </DialogActions>
            </Dialog>
        </div>
    );
};

export default WifiUserModel;
